<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">{{ params['title'] | translate }}</h4>
        <button type="button" class="btn btn-link fal fa-times close" (click)="clearValidationMessages(); hideModal.emit()" aria-label="Close"></button>
    </div>
    <div class="modal-body patient-form mat-form">
        <ng-template [ngIf]="!formLoading">
            <form [formGroup]="revocationForm">
                <ng-template #revocationTemplate>
                    <div *ngIf="revocationMessage" class="alert alert-success mb-2" role="alert">
                        <span class="fas fa-exclamation-circle mr-1" aria-hidden="true"></span>{{ revocationMessage | translate }}
                    </div>
                    <div class="form-group text-xs-center mb-2">
                        <h3>
                            {{ 'Revoke scientific agreement' | translate }}
                        </h3>
                    </div>
                    <div class="form-group mb-2">
                        {{ 'Do you want to withdraw the consent to the use of anonymous data for scientific purposes on behalf of the patient?' |
                        translate:{'name': patient.official_name} }}
                    </div>
                    <div formArrayName="revocations">
                        <div *ngFor="let revocation of revocationForm.controls.revocations.controls; let i=index;" [formGroup]="revocation" class="form-group">
                            <input type="checkbox" [id]="'revocation-' + i" formControlName="checked" />
                            <label [for]="'revocation-' + i">{{ revocation.controls.value.value | translate }}</label>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xs-12 text-xs-right">
                            <button type="button" class="btn btn-secondary" (click)="revocationPop.hide()">
                                {{ 'Cancel' | translate }}
                            </button>
                            <button type="button" class="btn btn-primary" (click)="onPatientAgreementRevoked()" [class.disabled]="!revocationForm.controls.selectedRevocations.valid">
                                {{ 'OK' | translate }}
                            </button>
                        </div>

                    </div>
                </ng-template>
            </form>

            <form [formGroup]="patientForm" novalidate>
                <div *ngIf="successMessage" class="row form-group" role="alert">
                    <div class="alert alert-info">
                        {{ successMessage | translate }}
                    </div>
                </div>
                <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                    <div class="col-sm-10">
                        <div class="alert alert-danger">
                            <div *ngFor="let error of errorMessage">
                                <i class="fas fa-exclamation-circle" aria-hidden="true"></i> {{ error | translate }}
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="type === 'read'" class="row form-group" role="alert">
                    <div class="col-sm-12 alert-success alert">
                        <i class="col-xs-1 fas fa-exclamation-circle" aria-hidden="true"></i>
                        <div class="col-xs-11">
                            <span class="block">{{ 'If you decide to reactivate this patient.' | translate }}</span>
                            <span class="block">{{ 'This action will be recorded.' | translate }}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div #givenNameFG class="form-group col-xs-6">
                        <mat-form-field class="ps-content">
                            <input type="input" matInput [placeholder]="'Given Name' | translate" formControlName="name" (focus)="onInputFocused($event, givenNameFG)"
                            />
                            <small class="form-text" [hidden]="patientForm.controls.name.valid || (patientForm.controls.name.pristine && !formSubmitted)">
                                <ng-container *ngIf="patientForm.controls.name.hasError('pattern'); else generalError" >
                                    {{ 'Please use alphabetic characters only.' | translate }}
                                </ng-container>
                                <ng-template #generalError>
                                    {{ 'Please enter the name of the patient' | translate }}
                                </ng-template>
                            </small>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div #lastNameFG class="form-group col-xs-6">
                        <mat-form-field class="ps-content">
                            <input type="input" matInput [placeholder]="'Last Name' | translate" formControlName="surname" (focus)="onInputFocused($event, lastNameFG)"
                            />
                            <small class="form-text" [hidden]="patientForm.controls.surname.valid || (patientForm.controls.surname.pristine && !formSubmitted)">
                                <ng-container *ngIf="patientForm.controls.surname.hasError('pattern'); else generalError" >
                                    {{ 'Please use alphabetic characters only.' | translate }}
                                </ng-container>
                                <ng-template #generalError>
                                    {{ 'Please enter the name of the patient' | translate }}
                                </ng-template>
                            </small>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div #birthdayFG class="form-group col-xs-4 birthday-form-group">
                        <div class="form-customized">
                            <label>{{ 'Date of Birth' | translate }}</label>
                            <my-date-picker class="kl-datepicker birthday-date-picker" (dateChanged)="onBirthdayChanged($event)" (inputFocusBlur)="onBirthdayFocusBlur($event, birthdayFG);"
                                (inputFieldChanged)="onBirthdayInputChanged($event)" placeholder="dd.mm.yyyy" [options]="dpkBirthdayOptions"
                                formControlName="birthday"></my-date-picker>
                            <div class="mat-input-underline mat-form-field-underline">
                                <span class="mat-input-ripple mat-form-field-ripple"></span>
                            </div>
                            <small class="form-text" [hidden]="isValidBirthday">
                                {{ 'Date format is dd.mm.yyyy' | translate }}
                            </small>
                        </div>
                    </div>
                    <div class="form-group col-xs-2 mb-0" *ngIf="patientForm.controls.birthday.value">
                        <mat-form-field class="ps-content">
                            <input type="input" [placeholder]="'Age' | translate" matInput [value]="age" readonly/>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mr-t--sm">
                    <div class="form-group col-xs-6">
                        <label>{{ 'Sex' | translate }}</label>
                        <br>
                        <input type="radio" id="gender-m" [value]="1" formControlName="gender" />
                        <label for="gender-m">{{ 'Male' | translate }}</label>
                        <br>
                        <input type="radio" id="gender-f" [value]="2" formControlName="gender" />
                        <label for="gender-f">{{ 'Female' | translate }}</label>
                        <br>
                        <input type="radio" id="gender-x" [value]="3" formControlName="gender" />
                        <label for="gender-x">{{ 'Gender X' | translate }}</label>
                    </div>
                </div>
                <div class="row">
                    <div #emailFG class="form-group col-xs-6">
                        <mat-form-field class="ps-content">

                            <input type="email" matInput [placeholder]="'Email Address' | translate" formControlName="email" (focus)="onInputFocused($event, emailFG, true)"/>
                            <small class="form-text" [hidden]="patientForm.controls.email.valid ||
                                        (patientForm.controls.email.pristine && !formSubmitted) ||
                                        patientForm.controls.email.disabled">
                                {{ 'Require this format: name@company.com' | translate }}
                            </small>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div #entryDateFG class="form-group col-xs-6 entry-date-form-group {{validateCssEntryDate}}">
                        <div class="form-customized {{ validateCssEntryDate }}">
                            <label>{{ 'Entry Date' | translate }} *</label>
                            <my-date-picker formControlName="entry_date" class="kl-datepicker entry-date-picker" placeholder="dd.mm.yyyy" [options]="dpkEntryDateOptions"
                                (inputFocusBlur)="onEntryDateFocusBlur($event, entryDateFG)" (inputFieldChanged)="onEntryDateInputChanged($event)"
                                required></my-date-picker>
                            <div class="mat-input-underline mat-form-field-underline">
                                <span class="mat-input-ripple mat-form-field-ripple"></span>
                            </div>
                            <small class="form-text" [hidden]="isValidEntryDate">
                                {{ 'Date format is dd.mm.yyyy' | translate }}
                            </small>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div #patientNumFG class="form-group col-xs-6">
                        <mat-form-field class="ps-content">
                            <input type="input" [maxlength]="16" matInput [placeholder]="'Patient Nr' | translate" formControlName="number" (focus)="onInputFocused($event, patientNumFG, true)"
                            />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-xs-6">
                        <mat-form-field class="ps-content">
                            <mat-select [placeholder]="'Language' | translate" required="required" formControlName="language_id">
                                <mat-option disabled value="null">
                                    {{ 'Language' | translate }}
                                </mat-option>
                                <mat-option *ngFor="let language of languages" [value]="language['id']">
                                    {{ language['name'] | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mr-b--md" *ngIf="patient.id">
                    <div class="col-xs-3 font-se-paragraph">
                        {{ 'Res. ID' | translate }}:
                        <b>{{ patient.id }}</b>
                    </div>
                    <div *ngIf="patient.is_agreement_exist" class="col-xs-8">
                        <button type="button" class="btn btn-link float-xs-left" [popover]="revocationTemplate" #revocationPop="bs-popover" [popoverTitle]="'Revoke patient agreement' | translate"
                                [outsideClick]="true" (onHidden)="resetRevocationForm()" placement="top" containerClass="popover-revocation-patient-agreement">
                            {{ 'Revoke patient agreement' | translate }}
                        </button>
                    </div>
                </div>
                <div class="row mr-t--sm">
                    <div class="col-xs-12 text-xs-left">
                        <button *ngIf="type !== 'read'" type="button" class="btn btn-primary mr-r--xs hidden" (click)="isValidBirthday && submitPatientWithSE.emit()">
                            {{ 'Start Self-Evaluation' | translate }}
                        </button>
                        <button *ngIf="params['action'] !== 'read'" type="button" class="btn btn-primary" (click)="isValidBirthday && submitPatient.emit()">
                            {{ 'Save' | translate }}
                        </button>
                        <button *ngIf="params['action'] !== 'read'" type="button" class="btn btn-secondary badge-pill" (click)="clearValidationMessages(); hideModal.emit()">
                            {{ 'Cancel' | translate }}
                        </button>
                        <button *ngIf="params['action'] === 'read'" type="button" class="btn btn-primary" (click)="submitPatient.emit()">
                            {{ 'Reactivate' | translate }}
                        </button>
                    </div>
                </div>
            </form>
        </ng-template>
    </div>
</div>
